export default "__VITE_ASSET__8f7ceb26__"